import { ApplicationConfig, importProvidersFrom, LOCALE_ID } from '@angular/core';
import { registerLocaleData } from '@angular/common';
import localePtAo from '@angular/common/locales/pt-AO';
import { providePrimeNG } from 'primeng/config';
import { provideRouter } from '@angular/router';
import { routes } from './app.routes';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { environment } from '../environments/environment';
import { BASE_PATH } from './shared/components/api/models/variables';
import { DialogService } from 'primeng/dynamicdialog';
import { ToastModule } from 'primeng/toast';
import { MessageService, ConfirmationService } from 'primeng/api';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { CustomPrimeNgPreset } from './custom-primeng-preset';
import { provideAnimations } from '@angular/platform-browser/animations';
import { authInterceptor } from './auth/interceptors/auth.interceptor';

registerLocaleData(localePtAo, 'pt-AO');

const ptTranslation = {
  accept: 'Sim',
  reject: 'Não',
  today: 'Hoje',
  clear: 'Limpar',
  dateFormat: 'dd/mm/yy',
  dayNames: ['Domingo', 'Segunda-feira', 'Terça-feira', 'Quarta-feira', 'Quinta-feira', 'Sexta-feira', 'Sábado'],
  dayNamesShort: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'],
  dayNamesMin: ['D', 'S', 'T', 'Q', 'Q', 'S', 'S'],
  monthNames: ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'],
  monthNamesShort: ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'],
  chooseYear: 'Ano',
  chooseMonth: 'Mês',
  chooseDate: 'Data',
  weekHeader: 'Sem'
};

export const appConfig: ApplicationConfig = {
  providers: [
    provideAnimations(),
    provideRouter(routes),
    providePrimeNG({
      ripple: true,
      theme: {
        preset: CustomPrimeNgPreset,
        options: {
          darkModeSelector: false || 'none',
        }
      },
      translation: ptTranslation
    }),
    provideHttpClient(withInterceptors([authInterceptor])),
    { provide: BASE_PATH, useValue: environment.apiurl },
    { provide: LOCALE_ID, useValue: 'pt-AO' },
    DialogService,
    importProvidersFrom(
      ToastModule,
      ConfirmDialogModule
    ),
    MessageService,
    ConfirmationService
  ]
};
